import { Component, Event, EventEmitter, Prop, h } from '@stencil/core';

@Component({
  tag: 'input-select-secondary',
  styleUrl: 'input-select-secondary.css',
})
export class InputSelectSecondary {
  @Prop() errorMessage: string = '';
  @Prop() hasError: boolean = false;
  @Prop() isDisabled: boolean = false;
  @Prop() label: string = '';
  @Prop() options: { value: string; label: string }[] = [];
  @Prop({ mutable: true, reflect: true }) value: string = null;
  @Prop() testId: string = '';

  @Event() valueChange: EventEmitter<string>;

  onInputChange(e) {
    const value = this.options[e.target.selectedIndex - 1]?.value || null;
    this.value = value;
    this.valueChange.emit(value);
  }

  shouldDisplayError() {
    return this.hasError && this.errorMessage;
  }

  render() {
    const hasValue = !!this.value && this.value !== 'false';

    const labelClass = {
      'input-select-secondary__label': true,
      'input-select-secondary__label--has-value': hasValue,
      'input-select-secondary__label--disabled': this.isDisabled,
      'input-select-secondary__label--error': this.hasError,
    };

    const selectClass = {
      'input-select-secondary__select': true,
      'input-select-secondary__select--disabled': this.isDisabled,
      'input-select-secondary__select--error': this.hasError,
    };

    const iconClass = {
      'input-select__icon-container': true,
      'input-select__icon-container--disabled': this.isDisabled,
    };

    return (
      <div class="grid grid-rows-1 w-full">
        <label class="input-select-secondary">
          <select {...(this.testId ? { id: this.testId } : {})} data-testid={this.testId} class={selectClass} onInput={(e) => this.onInputChange(e)} disabled={this.isDisabled}>
            {this.renderOptions()}
          </select>
          <span class={labelClass}>{this.label}</span>
          <div class={iconClass}>
            <svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
        </label>
        <div>{this.shouldDisplayError() && <span class="text-xs pl-4 text-clrs-argo-red">{this.errorMessage}</span>}</div>
      </div>
    );
  }

  renderOptions() {
    return [{ label: '', value: null }].concat(this.options).map((o) => (
      <option value={o.value} selected={o.value === this.value}>
        {o.label || o.value}
      </option>
    ));
  }
}
